export default "__VITE_ASSET__BxzEFnGZ__"